<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bkht">
<h1 class="bkht"><a class="page" id="pi"></a>Patient Zero and the Making of the AIDS Epidemic</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mckay-0002.vue?942f67c8